import { handleResponse } from 'api/utils';
import getFetchOptions from 'utils/getFetchOptions';

export const updateMerchantOnboardingReview = async (host: string, merchantId: string): Promise<void> => {
  const options = await getFetchOptions('POST');
  return await fetch(`${host}/onboarding/${merchantId}/onboard-review`, options).then(handleResponse);
};
